import { Button } from "@/components/ui/button";
import { SubMenuItemType } from "@/types/menu";
import Image from '@/components/ui/Image';

interface FeatureBlockProps {
  item:  { label?: string; item?: SubMenuItemType };
}

export const FeatureBlock = ({ item }: FeatureBlockProps) => {
  if (!item) return null;

  return (
    <div className="relative flex flex-col gap-y-1 p-6 h-full justify-center">
      {item?.label && (
        <span className="paragraph-base text-secondary-foreground mb-10">{item?.label}</span>
      )}
      {item?.item?.image && (
      <div className="pb-6">
        <div className="relative h-full w-full">
          <Image
            src={item?.item?.image ?? ""}
            alt={item?.item?.title ?? ""}
            width={768}
            height={432}
            className="h-full w-full object-cover object-center rounded-lg"
          />
        </div>
      </div>
      )}
      {item?.item?.title && (
        <h6>{item?.item?.title}</h6>
      )}
      {item?.item?.subtitle && (
        <span className="paragraph-sm text-muted-foreground">{item?.item?.subtitle}</span>
      )}
      {item?.item?.hasButton && item?.item?.buttonText && (
        <div>
          <Button asChild variant={item?.item?.buttonStyle} size="sm" className="mt-4">
            <a href={item?.item?.link} className="inline-flex">
              {item?.item?.buttonText}
              {/* <span className="material-symbols-outlined w-4.5 h-4.5" style={{ fontSize: '18px' }}>
                arrow_forward
              </span> */}
            </a>
          </Button>
        </div>
      )}
    </div>
  );
};

FeatureBlock.displayName = 'NavFeatureBlock'; 